import React, {createContext} from "react";
import useListContext from "../../tools/useListContext";
import {ClientListRepository} from "../../repository/AdminDashboard/Client-Repository";
import toast from "react-hot-toast";
import {DeviceListRepository} from "../../repository/AdminDashboard/DeviceList_Repository";
import {useModal} from "../../tools/useModal";

const devicesContext = createContext()

const DevicesContextProvider = ({children}) => {
    const {
        handleUpdateListState,
        listState,
        onDevicePerPageChange,
        changePage,
        onSearchBtnClick,
    } = useListContext(getDevices)
    const {closeModal, openModal, modalState} = useModal();

    async function getDevices() {

        handleUpdateListState("loading", true)
        const response = await DeviceListRepository.getDevicesList(
            listState.searchQuery,
            listState.pageNumber,
            listState.pageLimit,
        );
        handleUpdateListState("loading", false)

        if (response.code !== 1) {
            toast.error(response.massage, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        handleUpdateListState("list", response.DeviceList_data)
        handleUpdateListState("countAll", response.countAllPages)
    }

    function onDeviceDelete(item) {
        openModal("device", item)
    }

    function onBrokerDelete(item) {
        openModal("broker", item)
    }

    async function deleteDeviceCallback() {
        const response = await DeviceListRepository.delete(modalState.selectedItem.id);
        if (response.code !== 1) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        closeModal()
        await getDevices();

    }

    async function deleteBrokerCallback() {
        const response = await DeviceListRepository.delete(modalState.selectedItem.id);
        if (response.code !== 1) {
            toast.error(response.message, {
                className: "text-12 text-dark-blue-200",
            });
            return;
        }
        closeModal()
        await getDevices();
    }


    return (
        <devicesContext.Provider
            value={{
                onBrokerDelete,
                onDeviceDelete,
                onSearchBtnClick,
                onDevicePerPageChange,
                modalState,
                changePage,
                deleteDeviceCallback,
                deleteBrokerCallback,
                closeModal,
                listState
            }}>
            {children}
        </devicesContext.Provider>
    )
}
export {DevicesContextProvider};

export function useDevicesContext() {
    return React.useContext(devicesContext);
}